import { render, staticRenderFns } from "./TypedSignature.vue?vue&type=template&id=64acbc96&scoped=true&"
import script from "./TypedSignature.vue?vue&type=script&lang=js&"
export * from "./TypedSignature.vue?vue&type=script&lang=js&"
import style0 from "./TypedSignature.vue?vue&type=style&index=0&id=64acbc96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acbc96",
  null
  
)

export default component.exports